<template>
  <Modal v-model="IsOpenModal" :closable="false" :mask-closable="false" :width="30" :footer-hide="true"
    :title="operationType==1?'新增部门角色':'编辑部门角色'">
    <Form ref="departRoleInfo" :model="departRoleInfo" :rules="ruleValidate">
      <FormItem prop="bk_expl">
        <Input class="ys_input_border_bottom" v-model="departRoleInfo.bk_expl" placeholder="请输入部门角色名称" />
      </FormItem>
      <FormItem prop="dept_id">
        <Select v-model="departRoleInfo.dept_id" placeholder="请选择所属部门" :disabled="operationType==2">
          <Option v-for="(item,index) in DepartMentList" :key="index" :value="item.dept_id">
            {{item.dept_full_cname}}
          </Option>
        </Select>
      </FormItem>
      <FormItem prop="role_code">
        <Select v-model="departRoleInfo.role_code" placeholder="请选择角色名称" :disabled="operationType==2">
          <Option v-for="(item,index) in DepartRoleTypeList" :key="index" :value="item.role_code">
            {{item.role_cn_name}}
          </Option>
        </Select>
      </FormItem>
    </Form>
    <!-- 按钮组 -->
    <div class="btnGroup">
      <Button class="ys-cancel" @click="handleClick(1)">取消</Button>&nbsp;&nbsp;
      <Button class="ys-confirm" @click="handleClick(2)">{{operationType==1?'保存':'修改'}}</Button>
    </div>
  </Modal>
</template>
<script>
  export default {
    name: "AddDepartRole",
    props: {
      // 是否打开弹框
      IsOpenModal: {
        type: Boolean,
        default: false
      },
      // 操作状态 1 新增  2 编辑
      operationType: {
        type: Number,
        default: 1
      },
      // 部门列表
      DepartMentList: {
        type: Array,
        default: () => []
      },
      // 部门角色类型数据
      DepartRoleTypeList: {
        type: Array,
        default: () => []
      },
      // 编辑所需的部门角色详细数据信息
      EditDepartRoleInfo: {
        type: Object,
        default: () => ({})
      },
    },
    data() {
      return {
        departRoleInfo: {
          dept_id: "", // 部门ID
          role_code: "", // 角色ID 
          bk_expl: "", // 部门角色名称
        },
        ruleValidate: {
          bk_expl: [{
            required: true,
            message: '请输入部门角色名称',
            trigger: 'blur'
          }],
          dept_id: [{
            required: true,
            message: '请选择部门',
            trigger: 'change'
          }],
          role_code: [{
            required: true,
            message: '请选择角色',
            trigger: 'change'
          }],
        }
      }
    },
    mounted() {
      // 表单重置
      this.$refs['departRoleInfo'].resetFields();
    },
    methods: {
      handleClick(index) {
        // 1 取消   2 保存
        if (index === 1) {
          this.$emit("on-handleClick", index);
        } else {
          this.$refs['departRoleInfo'].validate((valid) => {
            if (valid) {
              if (this.operationType == 1 && this.departRoleInfo.dprl_code) {
                delete this.departRoleInfo.dprl_code
              }
              this.$emit("on-handleClick", index, this.departRoleInfo);
            } else {
              this.$Message.error('请完善部门角色信息!');
            }
          })
        }
      }
    },
    watch: {
      IsOpenModal(newInfo) {
        // 表单重置
        newInfo ? this.$refs['departRoleInfo'].resetFields() : ""
      },
      EditDepartRoleInfo(newValue) {
        if (this.operationType == 2) {
          this.departRoleInfo = newValue;
        }
      },
    }
  }
</script>
<style lang="less" scoped>
  .btnGroup {
    height: 50px;
    width: 100%;
    padding-right: 20px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
</style>